var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('QHforget',{ref:"QHforget",on:{"hello":_vm.hello,"success":_vm.success}}),_c('QHlogin',{ref:"QHlogin",on:{"hello":_vm.hello,"success":_vm.success}}),_c('QHzhuce',{ref:"QHzhuce",on:{"hello":_vm.hello,"success":_vm.success}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }